import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 40);
    }
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const linkClass = scrolled || !isHome
    ? "text-foreground-700 hover:text-foreground-950"
    : "text-white/90 hover:text-white";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-background-200/60"
          : "bg-black/30 backdrop-blur-sm"
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="font-heading text-xl font-semibold tracking-tight cursor-pointer flex items-center gap-2"
          >
            <h1 className={`text-xl font-heading font-semibold ${scrolled || !isHome ? "text-foreground-950" : "text-white"}`}>
              Superbuy Study
            </h1>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`whitespace-nowrap px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${linkClass}`}
            >
              Home
            </Link>
            <Link
              to="/shopping-guide"
              className={`whitespace-nowrap px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${linkClass}`}
            >
              Shopping Guide
            </Link>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className={`whitespace-nowrap px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer ${linkClass}`}
            >
              Main Site
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap ml-3 px-5 py-2 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled || !isHome ? "text-foreground-900" : "text-white"
            }`}
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-200 shadow-lg">
          <div className="px-6 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className="px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer flex items-center gap-2"
            >
              <i className="ri-home-4-line text-base"></i>
              Home
            </Link>
            <Link
              to="/shopping-guide"
              className="px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer flex items-center gap-2"
            >
              <i className="ri-book-open-line text-base"></i>
              Shopping Guide
            </Link>
            <Link
              to="/article/superbuy-spreadsheet-guide"
              className="px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer flex items-center gap-2"
            >
              <i className="ri-article-line text-base"></i>
              Ultimate Guide
            </Link>
            <Link
              to="/article/how-to-use-superbuy-spreadsheet"
              className="px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer flex items-center gap-2"
            >
              <i className="ri-guide-line text-base"></i>
              How to Use
            </Link>
            <Link
              to="/article/is-superbuy-safe"
              className="px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer flex items-center gap-2"
            >
              <i className="ri-shield-check-line text-base"></i>
              Safety Guide
            </Link>
            <div className="border-t border-background-200 my-1"></div>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-background-100 rounded-lg cursor-pointer flex items-center gap-2"
            >
              <i className="ri-external-link-line text-base"></i>
              Main Site
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap px-4 py-2.5 mt-1 rounded-full bg-primary-500 text-white text-sm font-semibold text-center hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Buy It Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}